import _objectSpread from '@babel/runtime/helpers/objectSpread2';

// Generate UUID
function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
function getId() {
  var _crypto;
  // eslint-disable-next-line no-undef
  return typeof crypto !== 'undefined' && typeof ((_crypto = crypto) === null || _crypto === void 0 ? void 0 : _crypto.randomUUID) === 'function' ?
  // eslint-disable-next-line no-undef
  crypto.randomUUID() : // TODO: remove when everything is on node 16 and browser support is stable
  "".concat(s4() + s4(), "-").concat(s4(), "-").concat(s4(), "-").concat(s4(), "-").concat(s4()).concat(s4()).concat(s4());
}
function addIdToItem(item) {
  return _objectSpread(_objectSpread({}, item), {}, {
    id: item.id ? item.id : getId()
  });
}
function addIdToCollectionItems(collection) {
  return collection.map(addIdToItem);
}
export default getId;
export { addIdToCollectionItems, addIdToItem };